module.exports = __webpack_public_path__ + "public/Icons/25Contentmanagement.svg?711eda2a";